import type { Frame, MeshBuilder } from '../../mesh/meshBuilder';
import type { MasonryStyles } from './masonry';
import { CELLEZUSTERS } from './cellezustersPlan';
import { buildRangeRoofGables } from './conventRoofGables';

/** The three source-read Molenstraat gables cut into their host slope. */
export function buildCelleMolenRoof(
  builder: MeshBuilder,
  frame: Frame,
  styles: MasonryStyles
): void {
  const g = CELLEZUSTERS.roofGables;
  buildRangeRoofGables(
    builder,
    frame,
    styles,
    CELLEZUSTERS.ranges.find((r) => r.id === g.range)!,
    { ...g, sill: 8.35, top: 9.2 }
  );
}
